var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"text","id":"myInput","placeholder":"Rechercher ...","title":"Type in a name"},on:{"keyup":function($event){return _vm.myFunction()}}}),_c('div',{staticStyle:{"border":"1px solid #1E6E53","padding":"1%","text-align":"center","display":"none"},attrs:{"id":"not_found_text"}},[_vm._v(" Aucun élément trouvé ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }